import React from 'react';

const DOM_Elements = () => {
  return (
    <div >
      <h1>DOM_Elements</h1>
      <p>Placeholder component for: "DOM Elements"</p>
    </div>
  );
};

export default DOM_Elements;
